import { getItem, setItem } from "Components/constants/SessionStores"; // Assuming you use this for session management
import React, { createContext, useState, useEffect, ReactNode } from "react";

interface PermissionsContextType {
  permissionsData: string[];
  updatePermissions: (newPermissions: string[]) => void;
}

export const PermissionsContext = createContext<
  PermissionsContextType | undefined
>(undefined);

export const PermissionsProvider = ({ children }: { children: ReactNode }) => {
  const [permissionsData, setPermissionsData] = useState<string[]>(() => {
    const storedPermissions = getItem("permissions");
    return storedPermissions ? JSON.parse(storedPermissions) : [];
  });

  const updatePermissions = (newPermissions: string[]) => {
    setPermissionsData(newPermissions);
    setItem("permissions", JSON.stringify(newPermissions));
  };

  useEffect(() => {
    const sessionPermissions = JSON.parse(String(getItem("permissions")));
    if (sessionPermissions) {
      setPermissionsData(sessionPermissions);
      setItem("permissions", JSON.stringify(sessionPermissions));
    }
  }, []);

  return (
    <PermissionsContext.Provider value={{ permissionsData, updatePermissions }}>
      {children}
    </PermissionsContext.Provider>
  );
};
